import { render, staticRenderFns } from "./service_select.vue?vue&type=template&id=8ce993e0&scoped=true&"
import script from "./service_select.vue?vue&type=script&lang=js&"
export * from "./service_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce993e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ce993e0')) {
      api.createRecord('8ce993e0', component.options)
    } else {
      api.reload('8ce993e0', component.options)
    }
    module.hot.accept("./service_select.vue?vue&type=template&id=8ce993e0&scoped=true&", function () {
      api.rerender('8ce993e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/select/service_select.vue"
export default component.exports